export default {
    namespaced: true,
    state: {
        filters_data: {
            group_list: [
                {value: 'year', name_en: 'Years', name_ru: 'Годы'},
                {value: 'quarter', name_en: 'Quarters', name_ru: 'Квартал'},
                {value: 'month', name_en: 'Months', name_ru: 'Месяцы'},
                {value: 'week', name_en: 'Weeks', name_ru: 'Недели'},
                {value: 'day', name_en: 'Days', name_ru: 'Дни'}],
            income_structure_list: [
                {value: 'all', name_en: 'All incomes', name_ru: 'Все доходы'},
                {value: 'source', name_en: 'Income sources', name_ru: 'Источники'},
                {value: 'type', name_en: 'Income types', name_ru: 'Типы дохода'},
                {value: 'involvement', name_en: 'Involvement', name_ru: 'Вовлеченность'}],
            expense_structure_list: [
                {value: 'all', name_en: 'All expenses', name_ru: 'Все расходы'},
                {value: 'group', name_en: 'Expense groups', name_ru: 'Группы расходов'},
                {value: 'category', name_en: 'Expense categories', name_ru: 'Категории расходов'},
            ]
        },
        filters: {
            date: {
                start: null,
                end: null,
            },
            type: 'income',
            main_chart_type: 'line',
            group_by: {value: 'month', name_en: 'Months', name_ru: 'Месяцы'},
            income_structure: {value: 'all', name_en: 'All incomes', name_ru: 'Все доходы'},
            expense_structure: {value: 'all', name_en: 'All expenses', name_ru: 'Все расходы'},
            income_source: null,
            expense_category: null,
            expense_group: null,
        },
    },
    actions: {},
    mutations: {
        updateFilter(state, payload) {
            state.filters[payload.name] = payload.value;
        },
        clearFilters(state) {
            state.filters.date.start = null;
            state.filters.date.end = null;
            state.filters.type = 'income';
            state.filters.main_chart_type = 'line';
            state.filters.group_by = {value: 'month', name_en: 'Months', name_ru: 'Месяцы'};
            state.filters.income_structure = {value: 'all', name_en: 'All incomes', name_ru: 'Все доходы'};
            state.filters.expense_structure = {value: 'all', name_en: 'All expenses', name_ru: 'Все расходы'};
        },
    }
}